import { css } from 'lit';
export default css `
  :host {
    display: grid;
    width: inherit;
    height: inherit;
  }
`;
//# sourceMappingURL=styles.js.map